<template>
	<div v-if="slideshow" data-component="slideshow">
		<div class="main-photo-container" @click="handleOpen">
			<ImageAsset v-if="slideshow.length" :asset="slideshow[0].photo" class="img" sizes="xsmall:400px medium:800px xlarge:1000px" />
		</div>

		<PhotosModal v-if="openSlideshow" :slideshow="slideshow" :close-fn="handleClose" />
	</div>
</template>

<script setup>
import { ImageAsset } from '~/components/core'
import { PhotosModal } from '~/components/modals/PhotosModal'

const props = defineProps({
	slideshow: { type: [Boolean, Array], default: () => [] },
})

const scroller = inject('$scroller')
const openSlideshow = ref(false)

const handleOpen = () => {
	scroller.value.stop()
	openSlideshow.value = true
}
const handleClose = () => {
	scroller.value.start()
	openSlideshow.value = false
}

defineExpose({
	handleOpen,
	handleClose,
})
</script>

<style lang="scss" scoped>
[data-component='slideshow'] {
	position: relative;

	height: 100%;

	.main-photo-container {
		position: relative;

		width: 100%;
		height: 100%;

		&:after {
			content: '';
			position: absolute;
			inset: 0;

			display: block;
			background-color: var(--color-black);
			opacity: 0.2;
		}

		.img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
}
</style>
